import axios from 'axios';

const axiosInstance = axios.create();

const getOrgIdFromUrl = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get('org') || null;
};

axiosInstance.interceptors.request.use(
    (config) => {
        const orgId = getOrgIdFromUrl();
        if (orgId) {
            config.headers['X-ORG-ID'] = orgId;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;

